export enum Environments {
  local = 'local',
  development = 'development',
  staging = 'staging',
  production = 'production',
}
